import React from 'react';

import { useListStyles as useStylesheet } from './stylesheets';
import { RecursiveShortcodeProps } from './Shortcode';

const List = ({ RecursiveShortcode, elements, ...rest }: RecursiveShortcodeProps) => {
  const { against, attributes, layout } = rest;
  const { styles } = useStylesheet({
    layout,
    against,
    attributes,
  });
  return (
    <ul style={styles.root}>
      {/* @ts-ignore: error when upgrading to @ux/config */}
      <RecursiveShortcode elements={elements} nl2br={false} {...rest} />
    </ul>
  );
};

List.displayName = 'List';

export default List;
